import _cloneDeep2 from "../util/cloneDeep";
import _defaultConfig from "../../stubs/defaultConfig.stub";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: () => _default
});
const _cloneDeep = _cloneDeep2;
const _defaultConfigStub = /*#__PURE__*/_interopRequireDefault(_defaultConfig);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const _default = (0, _cloneDeep.cloneDeep)(_defaultConfigStub.default.theme);
export default exports;